import React from 'react';
import CardMedia from '@material-ui/core/CardMedia';
import CardActionArea from '@material-ui/core/CardActionArea';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { withStyles }         from '@material-ui/core/styles';
import AuthService            from '../AuthService';
var Sinpermiso='/Multimedia/sinpermiso.png'
    
  /*                           CLASES DE ESTILO                       */

  var styles = theme =>({
    Dialog:{
      borderRadius: 30,
      margin:0,
      padding:0
    },
})
/*                                        EXPORT                                      */
export default withStyles(styles)(
    class Pagina404 extends React.Component {
        constructor(props) {
            super(props);
            this.actualizarbarra=props.actualizarbarra
            this.Auth = new AuthService();
            this.height=props.height
            this.movil_pequeño=props.movil_pequeño
            this.state = {
                isLoggin :          undefined,
            }
        }

        componentDidMount()
        {
            let _this = this;
            _this.actualizarbarra(false)
            this.Auth.loggedIn().then( function(b){
                _this.setState({ isLoggin: b})
                setTimeout(function(){ _this.actualizarbarra(true); }, 2000);
            })
        }

           /*                                          RENDER                          */
        render() {
           
            if (this.state.isLoggin === true )
            {
                return (
                            <div style={{width: '100%',bottom:0,top: window.innerHeight-120,background: 'white'}}>
                              <Card style={{boxShadow: 'none'}}>
                                <CardActionArea>
                                <CardContent style={{background: 'white'}}>
                                    <div style={{width: '100%',textAlign: 'center', fontSize: '18px', color: 'black'}}>
                                          No tiene permiso para esta ventana  
                                    </div>
                                </CardContent>
                                <CardMedia
                                    image={Sinpermiso}
                                    title=""
                                    style={{width: '100%',boxShadow: 'none',height: window.innerHeight-190,backgroundSize: this.movil_pequeño?'90%':'50%'}}
                                />
                                </CardActionArea>
                              </Card>
                             </div>
                    )
            }
            else if (this.state.isLoggin === false)
            {
                this.Auth.logout()
                window.location.reload();
                return; 
            }
            return null;
        }
    }
)